<div
    [id]="id"
    *ngIf="entityInternal"
    class="agpr-targetingResults-cardWrapper agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-matched-contact-view': cardMode === cardModes.editorMatchedContact,
        'agpr-targetingResults-cardWrapper-focused': selectedContactId === entityInternal.id
    }"
>
    <div
        role="group"
        class="agpr-targetingResults-card card"
        [ngClass]="{'agpr-targetingResults-card--expanded': expanded}"
        (agprClickUnless)="cardFocused()"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
        [attr.aria-label]="'Discover.universal.contactCard.label' | localize: {first: entityInternal.firstName, last: entityInternal.lastName}"
        (keydown)="onKeydown($event)"
    >
        <div class="agpr-targetingResults-card">
            <div class="agpr-targetingResults-card-left">
                <div
                    *ngIf="cardMode !== cardModes.editorMatchedContact"
                    class="agpr-targetingResults-card-checkbox"
                >
                    <agpr-checkbox
                        [id]="id + '_selectCheckbox'"
                        [disabled]="disableSelection"
                        [value]="entityInternal"
                        [hiddenLabel]="entityInternal.firstName + ' ' + entityInternal.lastName"
                        [initiallyFocusable]="initiallyFocusable"
                        [(ngModel)]="selectedResults"
                        (onChange)="checkboxClick()"
                    ></agpr-checkbox>
                    <div
                        *ngIf="selectedContactId === entityInternal.id"
                        class="agpr-targetingResults-card-selectedBar"
                    ></div>
                </div>

                <div class="agpr-targetingResults-card-thumbnail">
                    <img
                        class="agpr-targetingResults-card-thumbnail-img"
                        alt=""
                        [agprImageSrc]="entityInternal?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                        [agprDefaultImage]="imageDefault.SMALL_CONTACT"
                    />
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                        role="img"
                        class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                        [initiallyFocusable]="initiallyFocusable"
                    ></span>
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                        class="agpr-targetingResults-card-thumbnail-number"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                        [initiallyFocusable]="initiallyFocusable"
                    >
                        {{ listMemberships.length }}
                    </span>
                    <span
                        *ngIf="showBlueBadge"
                        class="agpr-targetingResults-card-thumbnail-number agpr-targetingResults-card-thumbnail-number-primaryBlue"
                        [agprTooltip]="blueBadgeTooltip"
                    ></span>
                </div>
                <div class="agpr-targetingResults-card-description-container">
                    <div class="agpr-targetingResults-card-description">
                        <div class="agpr-targetingResults-card-description-profile">
                            <a
                                class="agpr-targetingResults-card-description-name"
                                [id]="entityInternal.id + '_contact_profile'"
                                [agprInitiallyFocusable]="initiallyFocusable"
                                [agprTooltip]="'Discover.universal.contactNameLink.tooltip'"
                                tooltipPosition="top"
                            >
                                {{entityInternal.firstName}} {{entityInternal.lastName}}
                            </a>
                        </div>
                        <div
                            *ngIf="entityInternal.selectedEmployment?.jobTitle"
                            class="agpr-targetingResults-card-description-jobtitle"
                        >
                            <span
                                [pTooltip]="entityInternal.selectedEmployment.jobTitle"
                                tooltipPosition="top"
                            >
                                {{entityInternal.selectedEmployment.jobTitle}}
                            </span>
                        </div>
                        <div
                            *ngIf="entityInternal.selectedEmployment?.outlet?.name"
                            class="agpr-targetingResults-card-description-outlet"
                        >
                            <!-- do not change the indent, otherwise, it would display an extra space with underline when hover -->
                            <a
                                *ngIf="entityInternal.selectedEmployment?.outlet?.id"
                                class="agpr-targetingResults-card-description-outlet--leftAlign"
                                href="#out-profile"
                                [id]="entityInternal.id + '_outlet_profile'"
                                [agprInitiallyFocusable]="initiallyFocusable"
                                [agprTooltip]="'Discover.universal.outletLink.tooltip'"
                                tooltipPosition="top"
                                (click)="focusOutlet($event)"
                            >{{ entityInternal.selectedEmployment.outlet.name | localize}}</a>
                            <span
                                *ngIf="entityInternal.selectedEmployment?.outlet?.id"
                                role="img"
                                class="fa-kit fa-agpr-outlet-solid agpr-targetingResults-card-description-outlet-icon"
                                [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                            ></span>
                            <p *ngIf="!entityInternal.selectedEmployment?.outlet?.id"> {{ entityInternal.selectedEmployment.outlet.name }} </p>
                        </div>
                    </div>

                    <div class="agpr-targetingResults-card-details-badges">
                        <span
                            *ngFor="let badge of entityInternal.badges"
                            role="img"
                            class="agpr-targetingResults-card-badges {{badge.iconClass}}"
                            [agprTooltip]="badge.tooltip"
                            tooltipPosition="top"
                            [initiallyFocusable]="initiallyFocusable"
                        ></span>
                    </div>
                </div>
            </div>

            <div class="agpr-targetingResults-card-divider">
            </div>

            <div
                class="agpr-targetingResults-card-details-container agpr-targetingResults-card-right"
            >
                <div class="agpr-targetingResults-card-details">
                    <!-- targetAudienceRegions -->
                    <div
                        *ngIf="targetAudienceRegions"
                        class="agpr-targetingResults-card-details-field"
                    >
                        <div class="agpr-targetingResults-card-details-title">
                            {{ 'Discover.targeting.searchFieldLabels.targetAudienceRegion' | localize }}
                        </div>
                        <agpr-filter-summary
                            [(ngModel)]="targetAudienceRegions"
                            labelLookupValue="displayString"
                            labelLookupKey="collectionId"
                            [labelLookup]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)">
                        </agpr-filter-summary>
                    </div>

                    <!-- mediaMarkets -->
                    <div
                        *ngIf="mediaMarkets"
                        class="agpr-targetingResults-card-details-field"
                    >
                        <div class="agpr-targetingResults-card-details-title">
                            {{ 'Discover.recommendedRecipients.card.mediaMarkets' | localize }}
                        </div>
                        <agpr-filter-summary
                            [(ngModel)]="mediaMarkets"
                            labelLookupValue="displayString"
                            labelLookupKey="id"
                            [labelLookup]="journodexEnumsService.getMediaMarketsByIds.bind(journodexEnumsService)">
                        </agpr-filter-summary>
                    </div>


                    <!-- subjects -->
                    <div
                        *ngIf="subjects"
                        class="agpr-targetingResults-card-details-field"
                    >
                        <div class="agpr-targetingResults-card-details-title">
                            {{ 'Discover.recommendedRecipients.card.subjects' | localize }}
                        </div>
                        <agpr-filter-summary
                            [(ngModel)]="subjects"
                            labelLookupValue="name"
                            labelLookupKey="id"
                            [labelLookup]="journodexSubjectsService.getChildrenByIds.bind(journodexSubjectsService)">
                        </agpr-filter-summary>
                    </div>

                    <!-- coverageFocuses -->
                    <div
                        *ngIf="coverageFocuses"
                        class="agpr-targetingResults-card-details-field"
                    >
                        <div class="agpr-targetingResults-card-details-title">
                            {{ 'Discover.targeting.searchFieldLabels.coverageFocuses' | localize }}
                        </div>
                        <agpr-filter-summary
                            [(ngModel)]="coverageFocuses"
                            labelLookupValue="displayString"
                            labelLookupKey="enumValue"
                            [labelLookup]="journodexEnumsService.getCoverageFocuses()">
                        </agpr-filter-summary>
                    </div>

                    <!-- marketSectors -->
                    <div
                        *ngIf="marketSectors"
                        class="agpr-targetingResults-card-details-field"
                    >
                        <div class="agpr-targetingResults-card-details-title">
                            {{ 'Discover.recommendedRecipients.card.marketSectors' | localize }}
                        </div>
                        <agpr-filter-summary
                            [(ngModel)]="marketSectors"
                            labelLookupValue="displayString"
                            labelLookupKey="enumValue"
                            [labelLookup]="journodexEnumsService.getMarketSectors()">
                        </agpr-filter-summary>
                    </div>

                    <!-- targetAudiences -->
                    <div
                        *ngIf="targetAudiences"
                        class="agpr-targetingResults-card-details-field"
                    >
                        <div class="agpr-targetingResults-card-details-title">
                            {{ 'Discover.recommendedRecipients.card.targetAudiences' | localize }}
                        </div>
                        <agpr-filter-summary
                            [(ngModel)]="targetAudiences"
                            labelLookupValue="displayString"
                            labelLookupKey="enumValue"
                            [labelLookup]="journodexEnumsService.getTargetAudiences()">
                        </agpr-filter-summary>
                    </div>
                </div>


                <div class="agpr-targetingResults-card-details-toggle">
                    <agpr-button
                        *ngIf="entityInternal.numberOfEmployments > 1"
                        [id]="id + '_toggleExpansion'"
                        class="agpr-targetingResults-card-toggleEmploymentButton"
                        [style]="buttonTypes.icon"
                        [icon]="expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                        [expanded]="expanded"
                        ariaLabel="Discover.targeting.tooltips.expandEmployment"
                        [agprTooltip]="expanded ? 'Discover.distribution.statistics.lessDetails' : 'Discover.distribution.statistics.moreDetails'"
                        tooltipPosition="top"
                        [initiallyFocusable]="initiallyFocusable"
                        (click)="toggleExpansion()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="entityInternal.numberOfEmployments > 1"
        class="agpr-targetingResults-card-subcardGroup"
        [attr.aria-label]="'Discover.entityProfile.moreEmployments' | localize"
        [@showMoreContent]="animationState"
    >
        <ng-container>
            <div
                *ngFor="let employment of entityInternal.loadedEmployments; let i = index; let last = last"
                class="agpr-targetingResults-card agpr-targetingResults-card-subcard"
            >
                <div class="agpr-targetingResults-card-left">
                    <div
                        class="agpr-targetingResults-card-subcard-description"
                        [ngClass]="{'agpr-targetingResults-card-subcard-description-last': last}"
                    >
                        <agpr-radio
                            [id]="id + '_selectedEmployment_' + i"
                            [value]="employment"
                            name="{{entityInternal.id}}_contact_employment"
                            [(ngModel)]="entityInternal.selectedEmployment"
                            (ngModelChange)="selectedEmploymentChanged()"
                            [hiddenLabel]="employment.outlet?.name"
                        ></agpr-radio>
                        <div class="agpr-targetingResults-card-thumbnail agpr-targetingResults-card-subcard-thumbnail">
                            <img
                                class="agpr-targetingResults-card-subcard-thumbnail-img"
                                [agprImageSrc]="employment.outlet?.avatarUrl"
                                alt=""
                                [agprDefaultImage]="imageDefault.SMALL_OUTLET"
                            />
                        </div>

                        <div
                            class="agpr-targetingResults-card-description-container agpr-targetingResults-card-subcard-description-container"
                            [ngClass]="{'agpr-targetingResults-card-subcard-description-container--last': last}"
                        >
                            <div class="agpr-targetingResults-card-description">
                                <div class="agpr-targetingResults-card-subcard-name">{{employment.outlet?.name}}</div>
                                <div class="agpr-targetingResults-card-description-jobtitle agpr-targetingResults-card-subcard-description-jobTitle">{{employment.jobTitle}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="agpr-targetingResults-card-right">
                    <div
                        class="agpr-targetingResults-card-subcard-details"
                        [ngClass]="{'agpr-targetingResults-card-subcard-details-last': last}"
                    >
                        <div
                            *ngIf="employment.outlet?.uniqueVisitors"
                            class="agpr-targetingResults-card-subcard-details-circulation"
                        >
                            {{employment.outlet.uniqueVisitors.value | number}}
                        </div>
                        <div>{{employment.outlet?.geography?.displayString}}</div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="agpr-contextMenu bottom right">
        <agpr-button
            *ngIf="cardMode === cardModes.editorMatchedContact"
            [id]="id + '.expand'"
            [icon]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'"
            (click)="expandClicked()"
            class="contextMenu"
            tooltip="Discover.entityProfile.expand"
            tooltipPosition="top"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="entityInternal.isPrivate"
            [id]="id + '.editContact'"
            [icon]="'fa-regular fa-duotone fa-duotone fa-pen'"
            (click)="editContact(entityInternal)"
            class="contextMenu"
            tooltip="Discover.targeting.actions.editContact"
            tooltipPosition="top"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="entityInternal.isPrivate"
            [id]="id + '.deleteContact'"
            [icon]="'fa-regular fa-duotone fa-trash-can'"
            (click)="deleteContact(entityInternal)"
            tooltip="Discover.targeting.actions.deleteContact"
            tooltipPosition="top"
            class="contextMenu"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            [id]="id + '.manageList'"
            [icon]="'fa-regular fa-duotone fa-user-plus'"
            (click)="openManageListDialog(entityInternal)"
            tooltip="Discover.targeting.actions.manageLists"
            tooltipPosition="top"
            class="contextMenu"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
    </div>
</div>
